module.exports = __webpack_public_path__ + "static/media/conductv.18b1e2c4.jpg";